import axiosNodeInstance from "../../../_config/axios.config";
import config from "../../../_config/config";
import { showWarningMessage } from "../../../_uiComponents/ShowMessageSnack";
import { candidateAssessmentConstants } from "../../_constants";

//get assigned assessment kit details
export const get_assessment_kit_details_action = (id) => async (dispatch) => {
  dispatch({
    type: candidateAssessmentConstants.GET_ASSESSMENT_KIT_DETAILS_ACTION_REQUEST,
  });
  try {
    const response = await axiosNodeInstance.get(
      `${config.assessmentKits.publicDetails}${id}`
    );
    if (response.status) {
      dispatch({
        type: candidateAssessmentConstants.GET_ASSESSMENT_KIT_DETAILS_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: candidateAssessmentConstants.GET_ASSESSMENT_KIT_DETAILS_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);
    return e;
  }
};

// accept assessment kit
export const accept_assessment_kit_action = (id) => async (dispatch) => {
  dispatch({
    type: candidateAssessmentConstants.ACCEPT_ASSESSMENT_KIT_ACTION_SUCCESS,
  });
  try {
    const response = await axiosNodeInstance.post(
      `${config.assessmentKits.acceptAssessment}/${id}`
    );
    if (response.status) {
      dispatch({
        type: candidateAssessmentConstants.ACCEPT_ASSESSMENT_KIT_ACTION_REQUEST,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: candidateAssessmentConstants.ACCEPT_ASSESSMENT_KIT_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);
    return false
  }
};

// decline assessment kits
export const decline_assessment_kit_action = (id) => async (dispatch) => {
  dispatch({
    type: candidateAssessmentConstants.DECLINE_ASSESSMENT_KIT_ACTION_REQUEST,
  });
  try {
    const response = await axiosNodeInstance.post(
      `${config.assessmentKits.declineAssessmentKit}/${id}`
    );
    if (response.status) {
      dispatch({
        type: candidateAssessmentConstants.DECLINE_ASSESSMENT_KIT_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: candidateAssessmentConstants.DECLINE_ASSESSMENT_KIT_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);
    return e;
  }
};

// get assessment next question 
export const get_assessment_next_question_action = (id) => async (dispatch) => {
  dispatch({
    type: candidateAssessmentConstants.GET_ASSESSMENT_NEXT_QUESTION_ACTION_REQUEST,
  });
  try {
    const response = await axiosNodeInstance.get(
      `${config.assessmentKits.fetchNextQuestion.replace(
        ":assessmentAssignId",
        id
      )}`
    );
    if (response.status) {
      dispatch({
        type: candidateAssessmentConstants.GET_ASSESSMENT_NEXT_QUESTION_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: candidateAssessmentConstants.GET_ASSESSMENT_NEXT_QUESTION_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);
    return e;
  }
};

// save assessment question 
export const save_assessment_question_response_action =
  (id, data) => async (dispatch) => {
    dispatch({
      type: candidateAssessmentConstants.SAVE_ASSESSMENT_QUESTION_RESPONSE_ACTION_REQUEST,
    });
    try {
      const response = await axiosNodeInstance.post(
        config.assessmentKits.candidateResponse.replace(
          ":assignedQuestionId",
          id
        ),
        data
      );
      if (response.status) {
        dispatch({
          type: candidateAssessmentConstants.SAVE_ASSESSMENT_QUESTION_RESPONSE_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateAssessmentConstants.SAVE_ASSESSMENT_QUESTION_RESPONSE_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };

// // Get All Assessment kits
export const get_candidate_assigned_assessment_kits_data_action =
  () => async (dispatch) => {
    dispatch({
      type: candidateAssessmentConstants.GET_ASSIGNED_ASSESSMENT_KITS_ACTION_REQUEST,
    });
    try {
      const response = await axiosNodeInstance.get(
        config.assessmentKits.assignedAssessments
      );
      if (response.status) {
        dispatch({
          type: candidateAssessmentConstants.GET_ASSIGNED_ASSESSMENT_KITS_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateAssessmentConstants.GET_ASSIGNED_ASSESSMENT_KITS_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };

export const get_assigned_assessment_kit_details_data_action =
  (id) => async (dispatch) => {
    dispatch({
      type: candidateAssessmentConstants.GET_ASSIGNED_ASSESSMENT_KIT_DETAILS_ACTION_REQUEST,
    });
    try {
      const response = await axiosNodeInstance.get(
        config.assessmentKits.assignedAssessment.replace(":id", id)
      );
      if (response.status) {
        dispatch({
          type: candidateAssessmentConstants.GET_ASSIGNED_ASSESSMENT_KIT_DETAILS_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateAssessmentConstants.GET_ASSIGNED_ASSESSMENT_KIT_DETAILS_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };


  // submit assessment kits
export const submit_assessment_kit_action = (id) => async (dispatch) => {
  dispatch({
    type: candidateAssessmentConstants.SUBMIT_ASSESSMENT_KIT_ACTION_REQUEST,
  });
  try {
    const response = await axiosNodeInstance.post(
      `${config.assessmentKits.submitAssessmentKit}${id}`
    );
    if (response.status) {
      dispatch({
        type: candidateAssessmentConstants.SUBMIT_ASSESSMENT_KIT_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: candidateAssessmentConstants.SUBMIT_ASSESSMENT_KIT_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);
    return e;
  }
};